import type { ReferencedEntry } from 'contentful';

import { Subject } from 'api/contentful/contentTypes.cloverdotcom';
import type { BrowserBreakpoints } from 'utils/breakpoints';
import { getField } from 'utils/EntryUtil';

export const getBackgroundImageUrl = (
  browser: BrowserBreakpoints,
  backgroundImage?: ReferencedEntry<Subject>,
) => {
  if (!backgroundImage) return undefined;

  const image = getField(backgroundImage, 'image');
  const tabletImage = getField(backgroundImage, 'tabletImage');
  const mobileImage = getField(backgroundImage, 'mobileImage');

  const coverImage =
    (browser.is.mobile && mobileImage) || (browser.is.tablet && (tabletImage || mobileImage)) || image;

  const imageUrl = coverImage?.fields?.file?.url;

  if (!imageUrl) return undefined;

  return `url(${imageUrl})`;
};
